import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface Report {
  url: string
}

interface ClockifyReportResponse {
  reports: Array<Report>
}

class ClockifyReportService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt
      }
    });
  }
  async getReport(): Promise<AxiosResponse<ClockifyReportResponse>> {
    return await this.client.get("/clockifyreport");
  }
}

export default ClockifyReportService;
